import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import { formatterStrParam } from '../Utils/ParamUtils';
import { asString } from '../Utils/ValueUtils';
import { insertIntoString } from '../Utils/Other';

class TEDDisplayOrgNr extends BaseDisplayer {
  static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayOrgNr;

  defaultParams(): string {
    return 'ONSep="-"';
  }

  defaultDisplayLength(params: string = ''): number {
    return 13;
  }

  display(
    value: ValueType,
    displayText: boolean = true,
    params: string = ''
  ): string {
    const valAsStr = asString(value) || '';
    const { result: insertSep, value: sep } = formatterStrParam(
      'ONSep',
      params,
      this.defaultParams()
    );

    if (is10Numbers(valAsStr) && insertSep) {
      return insertIntoString(sep, valAsStr, 6);
    } else {
      return valAsStr;
    }
  }
}

const is10Numbers = (str: string): boolean => {
  if (str.length !== 10) {
    return false;
  }
  const regex = /^\d{10}$/;
  const result = regex.exec(str);

  return result ? true : false;
};

export { TEDDisplayOrgNr };
